<section data-testid="c360-timeline" class="c360-section">
  <header class="c360-section__head">
    <h2 class="c360-section__title">Health and flag timeline</h2>
    <p class="c360-section__subtitle">{{ isWeekly ? 'The weekly health score, with every flag the nightly job raised drawn behind it.' : 'The daily health score over 90 days, with every flag the nightly job raised drawn behind it.' }}</p>
  </header>
  <div class="c360-grid">
    <article data-testid="c360-health-card" class="c360-card c360-span-12">
      <div class="c360-card__head">
        <div>
          <h3 class="c360-card__title">{{ isWeekly ? 'Health score, 52 weeks' : 'Health score, 90 days' }}</h3>
          <p class="c360-card__description">Dashed lines mark the tiers; bands mark when a flag was raised. Zoom to look closer.</p>
        </div>
      </div>
      <div class="c360-card__body">
        <app-admin-dashboard-empty *ngIf="loaded && !hasScores" data-testid="c360-health-empty" icon="fa-regular fa-heart-pulse"
                                   [title]="'No health score yet'"
                                   [body]="isWeekly ? 'The nightly job has not scored this company in the last 52 weeks.' : 'The nightly job has not scored this company in the last 90 days.'"></app-admin-dashboard-empty>
        <div #chart data-testid="c360-health-chart" class="c360-chart c360-chart--lg" [hidden]="loaded && !hasScores"></div>
        <div *ngIf="hasScores" data-testid="c360-band-legend" class="c360-legend">
          <span class="c360-band c360-band--renewal">Renewal risk</span>
          <span class="c360-band c360-band--dark">Going dark</span>
          <span class="c360-band c360-band--usage">Usage falling</span>
          <span class="c360-band c360-band--spike">Spend spike</span>
        </div>
        <p *ngIf="loaded && !runs.length" data-testid="c360-no-flags" class="c360-note">No flags in the last 90 days.</p>
        <table *ngIf="runs.length" data-testid="c360-flag-runs" class="c360-table">
          <thead>
            <tr>
              <th scope="col">Flag</th>
              <th scope="col">Raised</th>
              <th scope="col">Until</th>
              <th scope="col">Outcome</th>
              <th scope="col">Reason</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let run of runs" data-testid="c360-flag-run">
              <td>{{ run.label }}</td>
              <td class="c360-nowrap">{{ run.from | date:'d MMM y':'UTC' }}</td>
              <td class="c360-nowrap">{{ run.ongoing ? 'Still raised' : (run.to | date:'d MMM y':'UTC') }}</td>
              <td>
                <span data-testid="c360-outcome" class="c360-pill" [attr.data-tone]="outcomeTone(run.outcome)"
                      [ngClass]="'outcome-' + run.outcome">{{ outcomeLabel(run.outcome) }}</span>
              </td>
              <td class="c360-table__reason">{{ run.reason }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </article>
  </div>
</section>
